import { useState } from 'react';
import Tippy from '@tippyjs/react';

// import "tippy.js/themes/light.css";
// import "tippy.js/dist/tippy.css";
import iconClose from '../../icons/close.svg';
import { useMediaQuery } from 'react-responsive';
import './tippy.css';
import './light.css';
import { forwardRef } from 'react';

// eslint-disable-next-line react/display-name
const Tooltip = forwardRef((props, ref) => {
  const isMobileOnly = useMediaQuery({
    query: '(max-width: 425px)',
  });
  const [icon, setIcon] = useState('icon-tip');
  const hiddenIcon = props.hiddenIcon || false;

  return (
    <Tippy
      content={
        <div>
          <div className='close-icon-container'>
            <span className='close-icon'>
              <img src={iconClose} />
            </span>
          </div>
          <div className='tooltip-message-box'>
            <i className='icon-svg icon-tip--blue' />
            <div className='tooltip-message' dangerouslySetInnerHTML={{ __html: props.message }} />
          </div>
        </div>
      }
      trigger='mouseenter click'
      triggerTarget={ref?.current}
      placement={isMobileOnly ? 'top' : props.placement}
      theme='light pragmago'
      offset={[0, 15]}
      arrow={false}
      onShow={() => setIcon('icon-tip--blue')}
      onHide={() => setIcon('icon-tip')}
    >
      <span>
        {props.children} {!hiddenIcon && <div ref={ref} className={`icon-svg ${icon}`} />}
      </span>
    </Tippy>
  );
});

export default Tooltip;
